import { connect } from 'react-redux';

import { makeGetMilestone } from 'selectors/milestones';

import GroupActions from 'components/GroupActions';

const ALLOWED_ACTIONS = ['tieToGoal', 'duplicate', 'move', 'createTemplate', 'unsetAsMilestone'];

const MilestoneActions = ({ id, className = 'milestone-actions-holder', innerClassName = 'milestone-actions-trigger', isList, milestoneProject }) => {
    return (
        <GroupActions
            className={className}
            innerClassName={innerClassName}
            allowedActions={ALLOWED_ACTIONS}
            type="milestone"
            id={id}
            milestoneId={isList ? undefined : id}
            projectId={milestoneProject}
        />
    );
}

const makeMapStateToProps = () => {
    const getMilestone = makeGetMilestone();

    return ({ milestones, tasks }, ownProps) => {
        const milestone = getMilestone(milestones.items, ownProps.id);

        return {
            isList: milestone?.is_list,
            milestoneProject: milestone?.project
        };
    };
}

export default connect(makeMapStateToProps)(MilestoneActions);
